<template>
  <v-dialog persistent :value="businessLocationModal" width="800">
    <v-card>
      <popup-heading 
      :title=" businessLocationObj.name ? businessLocationObj.name + ' LOCATIONS' : 'BUSINESS LOCATIONS'" 
      subtitle="List of locations for the business">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
        </template>
      </popup-heading>

        <v-layout  justify-center>
          <v-flex class="sm12 md12 lg12">
            <v-card-text class="pa-5" v-if="loading">
              <block-spinner></block-spinner>
            </v-card-text>
            <v-card-text class="pb-5" v-else>
               <div class="text-center">
                <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
              </div>
              <v-data-table
                :headers="headers"
                :items="businessLocations"
                :search="search"
                class="pb-4 tabulardata"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
                @page-count="pageCount = $event"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.name">
                      <td class="text-left">{{ item.name }}</td>
                    </tr>
                  </tbody>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  No results.
                </v-alert>
              </v-data-table>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      loading: false,
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      businessLocations: [],
      headers: [
        { text: 'Location', value: 'name', sortable: false , class: 'font-weight-bold'},
      
      ],
    };
  },
  computed: {
    ...mapGetters({
      businessLocationModal: 'business/businessLocation',
      businessLocationObj: 'business/businessLocationObj',
    }),
  },

  watch: {
    businessLocationObj(val) {
      if (!_.isEmpty(val)) {
        this.fetchBusinessLocations(val.id);
      }
    },
  },
  mounted() {
     this.closeModal();
  },
  methods: {

    /**
     * Get business list
     */
    fetchBusinessLocations(id) {
      this.loading = true;
      const url = `${Env.url}/api/v1/businesses/${id}/locations`;
      AuthApi.getApi(url)
        .then((res) => {
          this.loading = false;
          this.businessLocations = res.data.payload;
        })
        .catch(() => {
          this.loading = false;
          console.log('Unable to fetch business users.')
        });
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setBusinessLocation(false);
      this.businessUsers = [];
      this.setBusinessLocationObj({});
    },
    ...mapActions({
      setBusinessLocation: 'business/setBusinessLocation',
      setBusinessLocationObj: 'business/setBusinessLocationObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
